import { AppState } from '../../../types/types';
import React, { useState } from 'react';
//import { CustomerDataContext } from "../../../components/context/CustomerDataProvider";
import { Box, Container, Grid, Button, TextField } from "@mui/material";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';
import { IconButtonProps } from '@mui/material/IconButton';
import { AuthContext, ContactType, CustomerContactStatusResponse, SaveContactConfirmationResponse } from "./../../../types/apimodel";

import IconDigitalePost from './../../../assets/images/check.svg';
import Exclamationmark from './../../../assets/images/exclamationmark.svg';
import { KEY_AUTH_CONTEXT, loadSessionData } from '../../../util/store';
import LinkedappBackend from '../../../services/LinkedappBackend';
import { log } from '../../../util/util';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import ArrowLeftIcon from '@mui/icons-material/ArrowBackIos';

interface Props {
    appState: AppState;
    customerContactStatusResponse?: CustomerContactStatusResponse | null;
    value?: string | '';

}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));


const ContactChangeMobilCard: React.FC<Props> = (props) => {
    const [expanded, setExpanded] = useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const [isValidMobil, setIsValidMobil] = useState(false);
    const [mobil, setMobil] = useState('');
    const [changeRequested, setChangeRequested] = useState(false);

    const [inputTan, setInputTan] = useState('');
    const [inputTanError, setInputTanError] = useState(false);

    const [pendingChanges, setPendingChanges] = useState(false);


    const styles = {
        erneutSenden: {
            fontWeight: 'bold', // Fett darstellen
            cursor: 'pointer', // Cursor zur Hand ändern
        },
    };

    /**
     * 
     * @param mobile Sends a TAN to this number
     */
    const setCustomercontactMobilChange = (mobile: string) => {
        log("setCustomercontactMobilChange: " + mobile);
        if (mobile) {
            mobile = mobile.replaceAll("+", "00");
            mobile = mobile.replaceAll(" ", "");
            setMobil(mobile)
        }
        let linkid = loadSessionData('linkid');
        let authContext: AuthContext = loadSessionData(KEY_AUTH_CONTEXT);
        LinkedappBackend.sendContactConfirmation(linkid, authContext, ContactType.CELLPHONE, mobile).then((data) => {
            if (data !== null) {
                if (true !== data.success) {
                    // this.setState({...this.state, smsSending: false, pending: false, error: 'Da ist etwas schiefgegangen. Bitte probieren Sie es nochmal!'});

                } else {
                    // this.setState({...this.state, smsSending: false, pending: true});

                }
            }
        }).catch((error) => {
            //this.setState({...this.state, smsSending: false, pending: false, error: 'Auf unserem Server ist etwas schiefgegangen. Bitte probieren Sie es nochmal!'});
            log(error);
        });

    }

    /**
     * Starts the TAN sending workflow
     */
    const changeContactSendTan = () => {
        if (isValidMobil) {
            setExpanded(false);
            setChangeRequested(true);
            setCustomercontactMobilChange(mobil);
        }
    }

    /**
     * Checks the TAN
     */
    const validateTan = () => {
        log("validateTan: " + inputTan);
        setInputTanError(false);
        if (inputTan && inputTan !== '') {
            let linkid = loadSessionData('linkid');
            // let authContext: AuthContext = loadSessionData(KEY_AUTH_CONTEXT);

            LinkedappBackend.saveContactConfirmation(linkid, inputTan).then((response: SaveContactConfirmationResponse) => {
                if (true === response.success) {
                    // Button freischalten
                    setPendingChanges(true);
                    setInputTanError(false);
                } else {
                    /*
                    if (this.mounted === true) {
                        this.setState({...this.state, pending: true, confirmed: false, tanError: response.error ? "Die TAN ist nicht korrekt." : null, tanTesting: false});
                    }
                    */
                    setInputTanError(true);
                }
            }).catch((error) => {
                /*
                if (this.mounted === true) {
                    this.setState({...this.state, pending: true, confirmed: false, tanError: "Die TAN ist nicht korrekt.", tanTesting: false});
                }
                */
                setInputTanError(true);
            });
        } else {
            setInputTanError(true);
        }
    }


    /**
     * 
     * @param newValue New mobile number
     */
    const handleChangeMobilInput = (newValue) => {
        setMobil(newValue)

        if (matchIsValidTel(newValue, {
            onlyCountries: ["DE"],
        }) && newValue !== '') {
            setIsValidMobil(true);
            setMobil(newValue)

        } else {
            setIsValidMobil(false);
        }// true | false

    }

    const cancelMobileChange = () => {
        setPendingChanges(false);
        setMobil(null);
        setChangeRequested(false);
    }

    const doNothing = (e) => {
        e.stopPropagation();
    }

    const getWithoutCountry = (nr: string) => {
        if (nr && nr.startsWith("0049")) {
            return nr.slice(4);
        } else {
            return nr;
        }
    }

    if (changeRequested && isValidMobil && props.customerContactStatusResponse?.mobil === mobil) {
        setChangeRequested(false);
        setPendingChanges(false);
    }
    //const { customer } = useContext(CustomerDataContext);
    return <Container maxWidth="lg" >
        <Grid item xs={12} sx={{}}>
            <Card sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
            }}>
                <CardHeader sx={{ alignSelf: "flex-end", marginBottom: "-90px", overflow: "100" }}

                    action={
                        <IconButton
                            onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="mehr anzeigen"
                        >

                            <ExpandMore
                                expand={expanded}
                                onClick={handleExpandClick}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </IconButton>
                    }
                />

                <CardContent sx={{ alignSelf: "flex-start", width: '100%', }} onClick={handleExpandClick} >
                    <Box sx={{ display: "flex" }}>
                        <h4>Ihre Mobilfunknummer</h4>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Grid container spacing={2} justifyContent="space-between">
                            <Grid item xs={7} sm={7} md={5} lg={5}>

                                {!pendingChanges && <MuiTelInput
                                    defaultCountry="DE"
                                    forceCallingCode
                                    onlyCountries={['DE']}
                                    value={getWithoutCountry(props.customerContactStatusResponse?.mobil)}
                                    disabled={true}
                                    onClick={handleExpandClick}
                                    sx={{ marginTop: "-25px" }}
                                    className='readonly'
                                    contentEditable={false}
                                ></MuiTelInput>}


                                {/* 
                            {!pendingChanges && <Box>{props.customerContactStatusResponse?.mobil}</Box>}
                              */}

                                {pendingChanges && <Box>Wird aktualisiert.</Box>}
                            </Grid>
                            {!changeRequested && props.customerContactStatusResponse?.mobilConfirment && <Grid item xs={5} sm={5} md={7} lg={7}>
                                <Box> <Box component="img" sx={{ width: { xs: '15px', sm: '15px', md: '15px', lg: '15px' }, marginLeft: '1rem', marginRight: '0.5rem' }} alt="Postfach" src={IconDigitalePost}></Box> verifiziert</Box>
                            </Grid>}

                            {!pendingChanges && changeRequested && isValidMobil && props.customerContactStatusResponse?.mobil !== mobil && <Grid item xs={12} sm={12} md={7} lg={7}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}> <Box component="img" sx={{ width: { xs: '15px', sm: '15px', md: '15px', lg: '15px' }, marginLeft: '1rem', marginRight: '0.5rem', paddingTop: '5px' }} alt="Postfach" src={Exclamationmark}></Box> <Box >Bestätigen Sie Ihre Mobilfunknummer durch die Eingabe der TAN, die wir Ihnen per SMS zugeschickt haben.<br /><span onClick={changeContactSendTan} style={styles.erneutSenden}>erneut senden</span></Box></Box>
                            </Grid>}


                            {!pendingChanges && changeRequested && isValidMobil && props.customerContactStatusResponse?.email !== mobil && <Grid item xs={12} sm={12} md={5} lg={5} >
                                <TextField
                                    label="TAN"
                                    type="text"
                                    id="tanEingabeFeld"
                                    value={inputTan}
                                    onClick={doNothing}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setInputTan(event.target.value);
                                    }}
                                    size="small"
                                    required={true}
                                    error={inputTanError}
                                ></TextField>
                            </Grid>}
                            {!pendingChanges && changeRequested && isValidMobil && props.customerContactStatusResponse?.email !== mobil && <Grid item xs={12} sm={12} md={7} lg={7}>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button className="button-wizard-back" sx={{ marginRight: "20px" }} startIcon={<ArrowLeftIcon />} title={'Zurück'} onClick={cancelMobileChange}></Button><Button sx={{ fontSize: "75%", maxWidth: "140px", minWidth: "140px" }} onClick={validateTan} disabled={!isValidMobil}> BESTÄTIGEN</Button>
                                </Box>
                            </Grid>}
                        </Grid>

                    </Box>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Grid container spacing={2} justifyContent="space-between" sx={{ marginTop: '10px' }}>
                            <Grid item xs={8} sm={8} md={6} lg={6}>
                                <Box sx={{ textAlign: 'left' }}>
                                    <MuiTelInput
                                        defaultCountry="DE"
                                        forceCallingCode
                                        onlyCountries={['DE']}
                                        value={getWithoutCountry(mobil)}
                                        label='Ihre neue Mobilfunknummer'
                                        required={true}
                                        disableDropdown
                                        onClick={doNothing}
                                        error={(!isValidMobil && mobil !== '')}
                                        onChange={handleChangeMobilInput}

                                    />
                                    {!isValidMobil && props.customerContactStatusResponse?.email === mobil && <p style={{ color: 'red' }}>Mobilfunknummer bereits verifiziert.</p>}
                                    {mobil && !isValidMobil && props.customerContactStatusResponse?.email !== mobil && <p style={{ color: 'red' }}>Bitte geben Sie eine gültige Mobilfunknummer ein.</p>}
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={4} md={6} lg={6}>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button sx={{ fontSize: "75%" }} onClick={changeContactSendTan} disabled={!isValidMobil}> Ändern</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Collapse>
                </CardContent>
            </Card>
        </Grid>
    </Container >
}

export default ContactChangeMobilCard;